module.exports = __webpack_public_path__ + "img/banner3.5fff0e3.png";